var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Gatilladores de la ejecución:")]),
    _c(
      "table",
      {
        staticClass: "uk-table uk-table-hover uk-table-divider",
        staticStyle: { "border-collapse": "collapse", width: "100%" }
      },
      [
        _vm._m(0),
        _vm._l(_vm.fileOnFlow.detalle.baseGatillaciones, function(gatillador) {
          return _c(
            "tr",
            {
              key: gatillador.id,
              staticStyle: { "border-bottom": "1px solid #e5e5e5" }
            },
            [
              _c("td", { staticClass: "uk-text-center uk-padding-small" }, [
                _c("span", [
                  +gatillador.aprobacionesGatilladorEstado === 1
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: { color: "green" },
                          attrs: { title: "Ejecutado" }
                        },
                        [_vm._v("check_circle")]
                      )
                    : +gatillador.aprobacionesGatilladorEstado === 2
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { title: "PROCESANDO" }
                        },
                        [_vm._v("spin")]
                      )
                    : +gatillador.aprobacionesGatilladorEstado === 3
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: { color: "red" },
                          attrs: { title: "ERROR" }
                        },
                        [_vm._v("cancel")]
                      )
                    : _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { title: "Pendiente" }
                        },
                        [_vm._v("indeterminate_check_box")]
                      )
                ])
              ]),
              _c("td", { staticClass: "uk-text-left uk-padding-small" }, [
                _vm._v(" " + _vm._s(gatillador.estado) + " ")
              ]),
              _c("td", { staticClass: "uk-text-left uk-padding-small" }, [
                _vm._v(" " + _vm._s(gatillador.proceso) + " ")
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm.fileOnFlow.detalle.pasosGatillaciones &&
    _vm.fileOnFlow.detalle.pasosGatillaciones.length > 0
      ? _c("div", [
          _c("hr", { staticStyle: { margin: "20px 0" } }),
          _c("h4", [_vm._v("Gatilladores de los pasos:")])
        ])
      : _vm._e(),
    _c(
      "table",
      {
        staticClass: "uk-table uk-table-hover uk-table-divider",
        staticStyle: { "border-collapse": "collapse", width: "100%" }
      },
      [
        _vm._m(1),
        _vm._l(_vm.gatillacionesPasos, function(gatillador) {
          return _c(
            "tr",
            {
              key: gatillador.id,
              staticStyle: { "border-bottom": "1px solid #e5e5e5" }
            },
            [
              _c("td", { staticClass: "uk-text-center uk-padding-small" }, [
                _c("span", [
                  +gatillador.aprobacionesGatilladorEstado === 1
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: { color: "green" },
                          attrs: { title: "Ejecutado" }
                        },
                        [_vm._v("check_circle")]
                      )
                    : +gatillador.aprobacionesGatilladorEstado === 2
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { title: "PROCESANDO" }
                        },
                        [_vm._v("spin")]
                      )
                    : +gatillador.aprobacionesGatilladorEstado === 3
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: { color: "red" },
                          attrs: { title: "ERROR" }
                        },
                        [_vm._v("cancel")]
                      )
                    : _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { title: "Pendiente" }
                        },
                        [_vm._v("indeterminate_check_box")]
                      )
                ])
              ]),
              _c("td", { staticClass: "uk-text-left uk-padding-small" }, [
                _vm._v(" " + _vm._s(gatillador.estado) + " ")
              ]),
              _c("td", { staticClass: "uk-text-center uk-padding-small" }, [
                _vm._v(" " + _vm._s(gatillador.paso.numeroPaso) + " ")
              ]),
              _c("td", { staticClass: "uk-text-left uk-padding-small" }, [
                _vm._v(" " + _vm._s(gatillador.proceso) + " ")
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "uk-text-center uk-padding-small" }, [
        _vm._v("Estado")
      ]),
      _c("th", { staticClass: "uk-text-left uk-padding-small" }, [
        _vm._v("Estado del gatillador")
      ]),
      _c("th", { staticClass: "uk-text-left uk-padding-small" }, [
        _vm._v("Proceso")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "uk-text-center uk-padding-small" }, [
        _vm._v("Estado")
      ]),
      _c("th", { staticClass: "uk-text-left uk-padding-small" }, [
        _vm._v("Estado del paso")
      ]),
      _c("th", { staticClass: "uk-text-left uk-padding-small" }, [
        _vm._v("Nº Paso")
      ]),
      _c("th", { staticClass: "uk-text-left uk-padding-small" }, [
        _vm._v("Proceso")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }